import { render, staticRenderFns } from "./PurchaseSessions.vue?vue&type=template&id=bf776702"
import script from "./PurchaseSessions.vue?vue&type=script&lang=js"
export * from "./PurchaseSessions.vue?vue&type=script&lang=js"
import style0 from "./PurchaseSessions.vue?vue&type=style&index=0&id=bf776702&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports